var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestionLineGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.75C7.5 6.45333 7.58797 6.16332 7.7528 5.91665C7.91762 5.66997 8.15189 5.47771 8.42598 5.36418C8.70006 5.25065 9.00166 5.22094 9.29264 5.27882C9.58361 5.3367 9.85088 5.47956 10.0607 5.68934C10.2704 5.89912 10.4133 6.16639 10.4712 6.45737C10.5291 6.74834 10.4994 7.04994 10.3858 7.32403C10.2723 7.59812 10.08 7.83238 9.83336 7.99721C9.58668 8.16203 9.29667 8.25 9 8.25V9M10.6875 14.25L9.6 15.7C9.3 16.1 8.7 16.1 8.4 15.7L7.3125 14.25H5.25C3.59315 14.25 2.25 12.9069 2.25 11.25V5.25C2.25 3.59315 3.59315 2.25 5.25 2.25H12.75C14.4069 2.25 15.75 3.59315 15.75 5.25V11.25C15.75 12.9069 14.4069 14.25 12.75 14.25H10.6875Z",
    stroke: "#48555B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 11.25,
    r: 0.75,
    fill: "#48555B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionLineGrey);
export default __webpack_public_path__ + "static/media/icon_question_line_grey.141f2c0f245395e55413e88257ebb422.svg";
export { ForwardRef as ReactComponent };